export const DEFAULT_CLASS =
  'text-chariot-text-primary  placeholder:text-chariot-text-secondary border border-chariot-stroke focus-visible:border-chariot-brand-primary focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-chariot-brand-primary';

export const ERROR_CLASS =
  'pr-10 ring-red-300 placeholder:text-red-300 focus-visible:ring-red-500 focus-visible:outline-hidden';

export const DISABLED_CLASS =
  'disabled:cursor-not-allowed disabled:bg-chariot-stroke disabled:text-chariot-text-secondary disabled:ring-gray-200';
